module.exports = __webpack_public_path__ + "static/Quinzey-Bold-cdba8778ac96269caa2ce9274b848449.otf";